class ComoCarousel extends HTMLElement {
  constructor() {
    super();
    const carouselId = this.getAttribute("id");
    this.swiperElement = this.querySelector(':scope > .swiper');
    this.paginationElement = this.querySelector(':scope > .swiper > .swiper-pagination');
    // this.navigationNextElement = this.querySelector(':scope > .swiper > .swiper-button-next');
    // this.navigationPrevElement = this.querySelector(':scope > .swiper > .swiper-button-prev');
    this.navigationNextElement = this.querySelector(`.swiper-button-next[data-carousel-id="${carouselId}"]`);
    this.navigationPrevElement = this.querySelector(`.swiper-button-prev[data-carousel-id="${carouselId}"]`);
    this.carousel = null;
    this.isInPopup = this.closest('.como-popup') ? true : false;
 
   this.init();
  }

  initWhenVisible() {
   this.init();
  }

  init() {
    if (this.carousel) return;

    this.carousel = new Swiper(this.swiperElement, {
      loop: this.isInPopup ? true : false,
      slidesPerView: this.isInPopup ? 1 : 1.50,
      spaceBetween: 24,
      pagination: {
        el: this.paginationElement,
        clickable: true,
      },

      navigation: {
        nextEl: this.navigationNextElement,
        prevEl: this.navigationPrevElement,
      },
      breakpoints: {
        640: {
          slidesPerView: this.isInPopup ? 1 : 2.06,
          spaceBetween: this.isInPopup ? 40 : 20,
          allowTouchMove: this.isInPopup ? true : true
        },
        768: {
          slidesPerView: this.isInPopup ? 1 : 3.06,
          spaceBetween: this.isInPopup ? 40 : 20,
          allowTouchMove: this.isInPopup ? false : false
        },
        1200: {
          shortSwipes: false,
          slidesPerView: this.isInPopup ? 1 : 4.06,
          spaceBetween: this.isInPopup ? 40 : 24,
          allowTouchMove: this.isInPopup ? false : false,
          simulateTouch: false,
          a11y: false,
          noSwipingSelector: 'button',
          watchSlidesProgress: true,
        },
      },
    });
    this.carousel.on('slideChange', () => {
      // pause all videos
      const videos = this.querySelectorAll("video");
      videos.forEach((video) => {
        video.pause();
      });
    });
  }

  
  disconnectedCallback() {
    if (this.carousel) {
      this.carousel.destroy();
    }
  }
}

customElements.define('como-carousel', ComoCarousel);

class ComoVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector("video");
    this.playButton = this.querySelector("button");
    this.parentPopup = this.closest("dialog")

    this.playButton.addEventListener("click", (e) => {
      e.stopPropagation();
      
      if (this.video.paused) {
        this.stopPlayingVideos();
        this.video.play();
      } else {
        this.video.pause();
      }

      this.playButton.blur();
    });

    this.updatePlayingStatus();
    this.video.addEventListener("play", this.updatePlayingStatus.bind(this));
    this.video.addEventListener("pause", this.updatePlayingStatus.bind(this));

    // if dialog is closed pause the video
    this.parentPopup.addEventListener("close", () => {
      this.video.pause();
    });
  }

  stopPlayingVideos() {
    const videos = document.querySelectorAll("video:not([muted])");
    videos.forEach((video) => {
      if (video !== this.video) {
        video.pause();
      }
    });
  }

  updatePlayingStatus(e) {
    if (this.video.paused) {
      this.setAttribute("data-is-playing", "false");
      this.playButton.setAttribute("aria-label", "Play");
    } else {
      this.setAttribute("data-is-playing", "true");
      this.playButton.setAttribute("aria-label", "Pause");
    }
  }
}

customElements.define(
  "como-video",
  ComoVideo
);